var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlansIncluded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78088 11.3475L1.88424 7.45086C1.78234 7.34772 1.66099 7.26584 1.52721 7.20995C1.39343 7.15406 1.24989 7.12528 1.10491 7.12528C0.959926 7.12528 0.816384 7.15406 0.682606 7.20995C0.548829 7.26584 0.427475 7.34772 0.32558 7.45086C0.222442 7.55276 0.140555 7.67411 0.0846669 7.80789C0.0287784 7.94167 0 8.08521 0 8.23019C0 8.37517 0.0287784 8.51871 0.0846669 8.65249C0.140555 8.78627 0.222442 8.90762 0.32558 9.00952L4.99041 13.6744C5.42461 14.1085 6.12601 14.1085 6.5602 13.6744L18.3615 1.88424C18.4646 1.78234 18.5465 1.66099 18.6024 1.52721C18.6583 1.39343 18.687 1.24989 18.687 1.10491C18.687 0.959925 18.6583 0.816384 18.6024 0.682606C18.5465 0.548829 18.4646 0.427475 18.3615 0.32558C18.2596 0.222442 18.1382 0.140555 18.0044 0.0846666C17.8706 0.0287781 17.7271 0 17.5821 0C17.4371 0 17.2936 0.0287781 17.1598 0.0846666C17.026 0.140555 16.9047 0.222442 16.8028 0.32558L5.78088 11.3475Z",
    fill: "url(#paint0_linear_6_1060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1060",
    x1: 0,
    y1: 7,
    x2: 18.687,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA40F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E80DC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIncluded);
export default __webpack_public_path__ + "static/media/plansIncluded.6532cbfb591aea094e938562c894acf2.svg";
export { ForwardRef as ReactComponent };